import React from 'react';
import { Award, Users } from 'lucide-react';
import { leadership, recognition } from '../data/profile';
import { Highlight } from '../types';
import { Section } from './ui';

const Column: React.FC<{ heading: string; icon: React.ReactNode; items: Highlight[] }> = ({ heading, icon, items }) => (
  <div className="reveal spotlight rounded-2xl border border-ink-700 bg-ink-900/60 p-6 sm:p-8">
    <h3 className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-fg-faint">
      <span className="text-accent">{icon}</span>
      {heading}
    </h3>
    <ul className="mt-6 divide-y divide-ink-700">
      {items.map((item) => (
        <li key={item.title} className="py-5 first:pt-0 last:pb-0">
          <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
            <p className="font-medium text-fg">{item.title}</p>
            {item.period && <p className="font-mono text-[11px] text-fg-faint">{item.period}</p>}
          </div>
          <p className="text-sm text-accent/90">{item.org}</p>
          <p className="mt-2 text-sm leading-relaxed text-fg-muted">{item.description}</p>
        </li>
      ))}
    </ul>
  </div>
);

const Leadership: React.FC = () => (
  <Section
    id="leadership"
    index="03"
    eyebrow="Leadership & recognition"
    title={
      <>
        Beyond the <em className="text-accent">day job</em>.
      </>
    }
  >
    <div className="grid gap-4 lg:grid-cols-2">
      <Column heading="Leadership" icon={<Users size={14} />} items={leadership} />
      <Column heading="Recognition" icon={<Award size={14} />} items={recognition} />
    </div>
  </Section>
);

export default Leadership;
